// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import opinionStatusEntity from './entities/opinion-status.json';
import opinionStatusMenu from '../pages/opinion-status/menu.json';
import opinionStatusFullForm from '../pages/opinion-status/forms/full.json';
import opinionStatusContextForm from '../pages/opinion-status/forms/context.json';
import opinionStatusMiniForm from '../pages/opinion-status/forms/mini.json';
import opinionStatusLookupForm from '../pages/opinion-status/forms/lookup.json';
import opinionStatusTableView from '../pages/opinion-status/views/table.json';
import opinionStatusDashboardView from '../pages/opinion-status/views/dashboard.json';

/** Тип запису «Статус висновку» зі сторінками пакета: меню, форми та подання з pages/opinion-status/. */
export const opinionStatusDefinition: IRecordTypeDefinition = {
  ...opinionStatusEntity,
  views: assembleViewSet({
      table: opinionStatusTableView,
      dashboard: opinionStatusDashboardView,
  }),
  form: opinionStatusFullForm,
  forms: { full: opinionStatusFullForm, context: opinionStatusContextForm, mini: opinionStatusMiniForm, lookup: opinionStatusLookupForm },
  menu: opinionStatusMenu,
} as IRecordTypeDefinition;
